import { isEmptyString } from '@/utils/string';

/** Minimum length required by the backend. */
export const MIN_PASSWORD_LENGTH = 10;
/** bcrypt caps at 72 bytes; stay under to leave room for multi-byte characters. */
export const MAX_PASSWORD_LENGTH = 70;

export function validatePasswordLength(password: string): string | null {
  if (isEmptyString(password) || password.length < MIN_PASSWORD_LENGTH || password.length > MAX_PASSWORD_LENGTH) {
    return `Password must be between ${MIN_PASSWORD_LENGTH} and ${MAX_PASSWORD_LENGTH} characters.`;
  }
  return null;
}
